// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"64":"34272719","469":"e7cbfca2"}[chunkId] + ".chunk.css";
};